import React from 'react';

import Flip from "@mui/icons-material/Flip";
import { Tooltip, createTheme } from '@mui/material';

export default function FlipIcon({flip, handleClick}) {
	const theme = createTheme();
	return (
        <React.Fragment>
			<Tooltip title="Flip Component">
				<Flip fontSize="small" style={{...flip.button}} sx={{position: 'absolute', color: theme.palette.grey[500], zIndex: 99, cursor: 'pointer'}} onClick={handleClick} />
			</Tooltip>
		</React.Fragment>
    );

}
